import React from 'react';

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}) {

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={(e) => {
        e.target.src = "publicpublic/assets/images/slazzer-preview-av4u0-1762512006110.png"
      }}
      {...props}
    />
  );
}

export default Image;
